'use strict';
import $ from 'jquery';

function togglePlay (video, $container, play) {
	if (play || video.paused || video.ended) {
		video.play();
	} else {
		video.pause();
	}
}

function toggleMute (video, $container) {
	video.muted = !video.muted;
	$container.toggleClass('unmuted', !video.muted);
}

function handleFullscreen (videoContainer) {
	if (isFullScreen()) {
		if (document.exitFullscreen) document.exitFullscreen();
		else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
		else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
		else if (document.msExitFullscreen) document.msExitFullscreen();
		//setFullscreenData(false);
		return false;
	} else {
		if (videoContainer.requestFullscreen) videoContainer.requestFullscreen();
		else if (videoContainer.mozRequestFullScreen) videoContainer.mozRequestFullScreen();
		else if (videoContainer.webkitRequestFullScreen) videoContainer.webkitRequestFullScreen();
		else if (videoContainer.msRequestFullscreen) videoContainer.msRequestFullscreen();
		//setFullscreenData(true);
		return true;
	}
}

function isFullScreen () {
	return !!(document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
}

export default function(selector) {

	// Video elements
	const videos = {
		selector: selector,
		$all: $(selector),
		cclass: '.video-container',
		$containers: $([])
	};

	// Template for controls
	const html = `
<div class="video-overlay">
  <button class="video-start"><svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="video-start-bg" d="m .66,37.62 c 0,0 .66,4.70 2.70,6.77 2.58,2.71 5.98,2.63 7.49,2.91 5.43,.52 23.10,.68 23.12,.68 .00,-1.3e-5 14.29,-0.02 23.81,-0.71 1.32,-0.15 4.22,-0.17 6.81,-2.89 2.03,-2.07 2.70,-6.77 2.70,-6.77 0,0 .67,-5.52 .67,-11.04 l 0,-5.17 c 0,-5.52 -0.67,-11.04 -0.67,-11.04 0,0 -0.66,-4.70 -2.70,-6.77 C 62.03,.86 59.13,.84 57.80,.69 48.28,0 34.00,0 34.00,0 33.97,0 19.69,0 10.18,.69 8.85,.84 5.95,.86 3.36,3.58 1.32,5.65 .66,10.35 .66,10.35 c 0,0 -0.55,4.50 -0.66,9.45 l 0,8.36 c .10,4.94 .66,9.45 .66,9.45 z" fill="#1f1f1e" fill-opacity="0.81"></path><path d="m 26.96,13.67 18.37,9.62 -18.37,9.55 -0.00,-19.17 z" fill="#fff"></path></svg></button>
</div>
<div class="video-controls">
  <div class="controls-top">
    <progress id="progress" value="0" min="0" max="1"></progress>
    <input class="video-progress" type="range" min="0" max="1" value="0" step="any">
  </div>
  <div class="controls-left">
    <button class="video-play" type="button">
      <svg class="video-paused" height="100%" version="1.1" viewBox="0 0 36 36" width="100%"><path class="control-fill" d="M 12,26 18.5,22 18.5,14 12,10 z M 18.5,22 25,18 25,18 18.5,14 z"></path></svg>
      <svg class="video-playing" height="100%" version="1.1" viewBox="0 0 36 36" width="100%"><path class="control-fill" d="M 12,26 16,26 16,10 12,10 z M 21,26 25,26 25,10 21,10 z"></path></svg>
    </button>
    <button class="video-mute" type="button">
      <svg class="video-muted" height="100%" version="1.1" viewBox="0 0 36 36" width="100%"><path class="control-fill" d="M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z"></path></svg>
      <svg class="video-unmuted" height="100%" version="1.1" viewBox="0 0 36 36" width="100%"><path class="control-fill" d="M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 Z M19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"></path></svg>
</button>
  </div>
  <div class="controls-right">
    <button class="video-fullscreen" type="button">
      <i class="glyphicon glyphicon-resize-full"></i>
      <i class="glyphicon glyphicon-resize-small"></i>
    </button>
  </div>
</div>`;

	// Attach controls to videos
	videos.$all.each(function () {

		const video = this;
		const $video = $(this);
		const $container = $video.parent();

		$video.prop('controls', false);
		$container.addClass(videos.cclass.substr(1)).append(html);
		if ($video.prop('autoplay')) {
			$container.addClass('playing');
			$container.removeClass('paused');
		}

		const $progress = $container.find('.video-progress');
		const $progressbar = $container.find('progress');

		// Attach control events
		$container.find('.video-overlay').on('click', () => { togglePlay(video, $container, true) });
		$container.find('.video-start').on('click', () => { togglePlay(video, $container, true) });
		$container.find('.video-play').on('click', () => { togglePlay(video, $container) });
		$container.find('.video-mute').on('click', () => { toggleMute(video, $container) });

		$container.find('.video-fullscreen').on('click', () => {
			if (handleFullscreen($container.get(0))) {
				$container.addClass('fullscreen');
			} else {
				$container.removeClass('fullscreen');
			}
		});

		$progress.on('input change', () => {
			video.currentTime = video.duration * $progress.val();
		});
		$progress.on('mousedown', () => {
			video.pause();
		});
		//$progress.on('mouseup', () => {
		//    video.play();
		//});

		// Attach video events
		$video.on('play', () => {
			$container.addClass('playing');
			$container.removeClass('paused');
		});
		$video.on('pause ended', () => {
			$container.addClass('paused');
			$container.removeClass('playing');
		});
		//$video.on('ended', () => {
		//    $container.removeClass('paused');
		//    $container.removeClass('playing');
		//});
		$video.on('timeupdate', () => {
			$progress.val(video.currentTime / video.duration);
			$progressbar.val(video.currentTime / video.duration);
		});
	});

	videos.$containers = $(videos.cclass);
	videos.$containers.on('click', (e) => { e.preventDefault(); e.stopPropagation(); });

	/*
        $('.map-expand').on('click', () => {
            map.$element.parent().addClass('fullscreen');
            map.instance.setOptions({ scrollwheel: true});
            gmaps.event.trigger(map.instance, 'resize');
        });

        $('.map-contract').on('click', () => {
            map.$element.parent().removeClass('fullscreen');
            map.instance.setOptions({ scrollwheel: false });
            gmaps.event.trigger(map.instance, 'resize');
        });

        $('.map-zoom-in').on('click', () => {
            map.instance.setZoom(map.instance.getZoom() + 1);
        });

        $('.map-zoom-out').on('click', () => {
            map.instance.setZoom(Math.max(0, map.instance.getZoom() - 1));
        });
    */
}
